import React from "react";
import { HStack, Text, VStack } from "@chakra-ui/react";
import { Switch, TextInput, Form } from "components";
import { useCurrentCase } from "duck";
import { Doctors } from "./components";
import {
  getValidationSchema,
  getDropOff,
  useUpdateDropOff,
  FormValues
} from "./duck";

const DropOff: React.FC = () => {
  const defaultValues = useCurrentCase(medicalCase =>
    getDropOff(medicalCase.data)
  );

  const onChange = useUpdateDropOff();

  return (
    <Form<FormValues>
      validationSchema={getValidationSchema()}
      defaultValues={defaultValues}
    >
      {({ setValue }) => (
        <>
          <Form.Watcher onChange={onChange} defaultValues={defaultValues} />
          <VStack spacing={6}>
            <TextInput
              type="text-area"
              name="admittingConcern"
              label="Admitting Concern (duration, location, etc.)"
              placeholder="Admitting Concern (duration, location, etc.)"
            />
            <HStack width="100%" alignItems="flex-start">
              <Switch
                wrapperProps={{ mt: "8px" }}
                name="evaluateTestAndTreat"
                label="Evaluate, test and treat as per discussion with"
                onChange={checked => {
                  setValue("evaluateTestAndTreat", checked);
                  if (!checked) {
                    setValue("doctor", null, { shouldValidate: true });
                  }
                }}
              />

              <Doctors />
            </HStack>
            <Switch
              name="performInitialEvaluation"
              label="Perform initial evaluation of my pet's health, then contact me about testing and treatment."
            />
            <Text>
              I understand that I will be informed of my pet&apos;s condition
              and care before or at the time of release. If extensive testing
              and treatment are necessary I will be informed and my
              authorization given before such tests and treatments are
              performed.
            </Text>
          </VStack>
        </>
      )}
    </Form>
  );
};

export default DropOff;
